// extracted by mini-css-extract-plugin
export var automation = "Tokens-module--automation--14114";
export var automationSelector = "Tokens-module--automationSelector--a068b";
export var automations = "Tokens-module--automations--fbcea";
export var badge = "Tokens-module--badge--4b4a9";
export var highlight = "Tokens-module--highlight--c28bc";
export var icon = "Tokens-module--icon--b7491";
export var item = "Tokens-module--item--a2a04";
export var label = "Tokens-module--label--01f8f";
export var prefix = "Tokens-module--prefix--b79ab";